import React from 'react';
import { Check, AlertCircle } from 'react-feather';
import {
  InlineShell,
  CardButton,
  type F8CardData,
  type OnAction,
} from './cardHelpers';

const ACTION_SCREENS: Record<string, string> = {
  message_sent: 'Messages',
  circle_joined: 'CircleDetail',
  post_created: 'PplTalk',
  tether_created: 'Contacts',
  profile_updated: 'UserProfile',
};

const ACTION_LABELS: Record<string, string> = {
  message_sent: 'Message sent',
  circle_joined: 'Joined circle',
  post_created: 'Post created',
  tether_created: 'Contact saved',
  profile_updated: 'Profile updated',
};

export default function ActionConfirmCard({
  card,
  onAction,
}: {
  card: F8CardData;
  onAction?: OnAction;
}) {
  const data = card?.data || {};
  const success = data.success !== false;
  const title: string =
    data.title || ACTION_LABELS[data.actionType] || data.actionType || 'Done';
  const summary: string = data.summary || '';
  const targetScreen = data.screen || ACTION_SCREENS[data.actionType] || 'Home';

  return (
    <InlineShell className={success ? 'f8c-confirm-success' : 'f8c-confirm-error'}>
      <div className="f8c-confirm-row">
        <div className={`f8c-confirm-icon${success ? '' : ' f8c-confirm-icon-error'}`}>
          {success ? <Check size={16} /> : <AlertCircle size={16} />}
        </div>
        <div className="f8c-confirm-body">
          <div className="f8c-confirm-title">{title}</div>
          {summary && <div className="f8c-confirm-summary">{summary}</div>}
        </div>
        <CardButton
          small
          onClick={() =>
            onAction?.({
              action: 'navigate',
              params: { screen: targetScreen, ...(data.navigationParams || {}) },
            })
          }
        >
          Open
        </CardButton>
      </div>
    </InlineShell>
  );
}
